export const defaultLanguage: string = "uz";
